export const FullDealEntryPointBannerTexts = {
  title: 'Подберём займ',
  badgeTitle: 'ЕСТЬ АКТИВНАЯ ЗАЯВКА',
  badgeTitleWithTime: `в течение 5 минут`,
} as const;
